import {useMutation} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";

import {useAuth} from "../../auth/AuthProvider";
import * as api from "../../api";
import {useFeedbackTools} from "../../components/FeedbackTools";
import {useTranslation} from "react-i18next";


const logError = (error) => console.log(error?.response?.data?.detail);


export const useSignInMutation = ({onError}) => {
    const auth = useAuth();
    return useMutation({
        mutationFn: async (data) => await auth.login(data.email, data.password, data.rememberMe),
        onError: onError ?? logError,
    });
};

export const usePasswordRecoveryMutation = () => {
    return useMutation({
        mutationFn: async (email) =>  await api.Auth.passwordRecovery(email, {skipGlobalErrorHandler: true}),
    });
};

export const usePasswordResetMutation = () => {
    const {t} = useTranslation(["auth"]);
    const navigate = useNavigate();
    const {showSuccessNotification} = useFeedbackTools();

    return useMutation({
        mutationFn: async (data) => await api.Auth.passwordReset(data, {skipGlobalErrorHandler: true}),
        onSuccess: () => {
            navigate('/auth/sign-in');
            showSuccessNotification(t('resetPassword.successMsg'));
        }
    });
};

export const useSendEmailConfirmationMutation = () => {
    const {t} = useTranslation(["auth"]);
    const {showSuccessNotification} = useFeedbackTools();

    return useMutation({
        mutationFn: async (data) => await api.Auth.sendEmailConfirmation(data, {skipGlobalErrorHandler: true}),
        onSuccess: () => showSuccessNotification(t('emailConfirmation.successMsg'))
    });
}

export const useConfirmEmailMutation = () => {
    return useMutation({
        mutationFn: async (data) => await api.Auth.confirmEmail(data, {skipGlobalErrorHandler: true}),
        onError: (error) => {
            logError(error);
        }
    });
}